import { objectiveOptions } from "@/app/training/training";
import { TrainingObjective } from "@/app/training/training-objective";
import { CheckBox } from "@/shared/components/atoms/CheckBox";
import { InputTextRight } from "@/shared/components/atoms/InputTextRight";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import { Select } from "@/shared/components/atoms/Select";
import { t } from "i18next";

type Props = {
  week: string;
  onWeekChange: (e: any) => void;
  ///=====
  objective: string;
  objectiveChange: (e: any) => void;

  //==
  onTrainingNameChange: (e: any) => void;
  name: string;

  ///=====
  trainingFormik: any;
  userQuery: any;
  personalInformationQuery: any;
  userId: any;
  age: any;
  genre: any;
  newPlan: any;
};

const TopTrainingEditor = ({
  week,
  onWeekChange,

  objective,
  objectiveChange,

  onTrainingNameChange,
  name,

  newPlan,

  ///=====
  trainingFormik,
  userQuery,

  personalInformationQuery,
  userId,
  age,

  genre,
}: Props) => {
  console.log("objective=====//", objective?.toLowerCase?.());

  return (
    <div>
      <h1 className="text-base font-semibold leading-6 text-gray-900 border-b border-gray-200 pb-3 mt-10 mb-5">
        {t("chat.app.training_plan")}
      </h1>

      {userId && (
        <div className="flex justify-between border-b border-gray-200 pb-3 mb-5">
          <h1 className="text-gray-700 font-bold text-lg">
            {userQuery?.data?.name}
          </h1>
          <h1 className="text-gray-700 font-bold text-lg">
            {genre ?? personalInformationQuery?.data?.sex} /{" "}
            {age ?? personalInformationQuery?.data?.age} años
          </h1>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <InputWithCornerHint
          label={t("user.views.name")}
          type="text"
          error={name && name !== "" ? false : true}
          disabled={false}
          onChange={onTrainingNameChange}
          value={name}
        />
        <div className="">
          <Select
            label={t("user.views.objective")}
            name="objective"
            
            disabled={!newPlan}
            options={objectiveOptions}
            onChange={(e: any) => objectiveChange(e)}
            value={objective?.toLowerCase?.()}
          />
          {objective?.toLowerCase?.() == TrainingObjective.Hypertrophy && (
            <div className="flex items-center">
              <CheckBox
                onChange={trainingFormik.handleChange}
                value={trainingFormik.values.download}
                name="download"
              />
              <p className="ml-2">{t("user.views.objective_download")}</p>
            </div>
          )}
        </div>

        <InputTextRight
          onChange={onWeekChange}
          name="weeks"
          type="number"
          value={week}
          label={t("user.views.week_text")}
          spanRight={t("user.views.weeks_input")}
          inputLarge={true}
        />
      </div>
    </div>
  );
};

export { TopTrainingEditor };
